"use strict";
var protobuf = module.exports = require(8);

protobuf.build = "full";

// Parser
protobuf.tokenize         = require(25);
protobuf.parse            = require(17);
protobuf.common           = require(2);

// Configure parser
protobuf.Root._configure(protobuf.Type, protobuf.parse, protobuf.common);
